// extracted by mini-css-extract-plugin
export default {"header":"styles_header__l5A4i","logo":"styles_logo__8odM0"};